import React from "react";
import PropTypes from "prop-types";
import { UserGroupInfoController } from "./controller";
import InfoTab from "../../../../components/InfoTab";
import {membersKey} from "./model";

function UserGroupInfo({
  description,
  businessFunction,
  noOfMembers,
  users,
  userGroupUniqueName,
  userGroupRepresentationName,
  userGroupName,
  userRoleKey,
  scope,
}) {
  const {
    isLoading,
    isErrorState,
    generalInfoProps,
    listOfTables,
    columnSelectProps,
    infoTabContainerId,
  } = UserGroupInfoController(
    description,
    businessFunction,
    noOfMembers,
    users,
    userGroupUniqueName,
    userGroupName,
    userGroupRepresentationName,
    userRoleKey,
    scope,
  );

  return (
    <InfoTab
      isLoading={isLoading}
      isErrorState={isErrorState}
      generalInfo={generalInfoProps}
      listOfTables={listOfTables}
      columnSelect={columnSelectProps}
      containerId={infoTabContainerId}
      userGroupUniqueName={userGroupUniqueName}
      isGroupMembersTable={userRoleKey === membersKey}
    />
  );
}

export default UserGroupInfo;

UserGroupInfo.propTypes = {
  noOfMembers: PropTypes.number,
  users: PropTypes.arrayOf(PropTypes.string),
  userGroupUniqueName: PropTypes.string,
  userGroupName: PropTypes.string,
  userGroupRepresentationName: PropTypes.string,
};
